import {Entity} from "./entity";
import {Issue} from "./issue.entity";
import {Employee} from "./employee.entity";
import {Expose, Transform} from "class-transformer";
import {container} from "tsyringe";
import {EmployeeRepository} from "../repositories/employee.repository";
import {IssueRepository} from "../repositories/issue.repository";
import {ChangeTracker} from "../../change-tracking/change-tracker";
import {DateTime} from "luxon";
import {Public} from "../../decorators/public.decorator";
import {typeInfo} from "../../decorators/type-info.decorator";
import {viewComponent} from "../../decorators/view-component.decorator";

export class EmployeeToIssueAssignment extends Entity<EmployeeToIssueAssignment> {

    @Public()
    @Expose()
    @Transform(({value}) => {
        if (!value) {
            return null;
        }
        const promise = container.resolve(IssueRepository).findOneById(value);
        Reflect.set(promise, `uid`, value);
        return promise;
    }, {toClassOnly: true})
    @Transform(({value}: { value: Promise<Issue> & { uid: string } }) => value.uid, {toPlainOnly: true})
    @typeInfo({isEnumerable: false, isPromise: true, isEntity: true, type: () => Issue})
    @viewComponent("ha-entity-viewer")
    issue: Promise<Issue> & { uid: string } | null = null;

    @typeInfo({isEnumerable: false, isPromise: true, isEntity: true, type: () => Employee})
    @viewComponent("ha-entity-viewer")
    @Public()
    @Expose()
    @Transform(({value}) => {
        if (!value) {
            return null;
        }
        const promise = container.resolve(EmployeeRepository).findOneById(value);
        Reflect.set(promise, `uid`, value);
        return promise;
    }, {toClassOnly: true})
    @Transform(({value}: { value: Promise<Issue> & { uid: string } }) => value.uid, {toPlainOnly: true})
    employee: Promise<Employee> & { uid: string } | null = null;

    @typeInfo({isEnumerable: false, isPromise: true, isEntity: true, type: () => Issue})
    @viewComponent("ha-timespan-viewer")
    @Public()
    @Expose()
    timeBudget: number = 0;

    @typeInfo({isEnumerable: false, isPromise: false, isEntity: false, type: () => DateTime})
    @viewComponent("ha-date-viewer")
    @Public()
    @Expose()
    @Transform(({value}) => !value ? null : DateTime.fromSQL(value, {zone: `utc`}), {toClassOnly: true})
    @Transform(({value}: { value: DateTime | null }) => value?.toUTC().toSQL() ?? null, {toPlainOnly: true})
    deletedAt: DateTime | null = null;

    constructor() {
        super();

        return ChangeTracker.create(this as EmployeeToIssueAssignment);
    }

    public toString(): string {
        return "Mitarbeiter-Zuweisung";
    }
}